module.exports = __webpack_public_path__ + "static/media/Maven.ce4193ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Maven.jpg
// module id = 441
// module chunks = 0